const News = () => {
    var Isotope = require('isotope-layout');
    var jQueryBridget = require('jquery-bridget');
    var imagesLoaded = require('imagesloaded');

    jQueryBridget('isotope', Isotope, $);
    jQueryBridget('imagesLoaded', imagesLoaded, $);

    var $postGrid = $('#post-content');
    var currentPage = 1; // Track the current page
    var maxPages = 1; // Will be updated dynamically
    var currentCategory = ''; // Track the current category for filtering
    var isLoading = false; // Flag to prevent multiple requests
    var activeFilter = null; // Track the active filter

    $postGrid.isotope({
        itemSelector: '.news-item',
        layoutMode: 'fitRows',
        transitionDuration: '0.5s',
    });

    // Function to update the Load More button visibility
    function updateLoadMoreButton() {
        if (currentPage < maxPages) {
            $('#load-more').show();
        } else {
            $('#load-more').hide(); // Hide if no more pages to load
        }
    }

    // Filter posts based on category
    $('.post-filters').each(function (i, buttonGroup) {
        var $buttonGroup = $(buttonGroup);

        $buttonGroup.on('click', '.post-filter__item', function (event) {
            event.preventDefault();
            var $button = $(event.currentTarget);
            var filterValue = $button.attr('data-filter').replace('.', ''); // Update current category

            // Check if the same filter is clicked again
            if (activeFilter === filterValue) {
                activeFilter = null; // Reset active filter
                currentCategory = ''; // Reset to no category (show all posts)
                currentPage = 1; // Reset page to 1

                $.ajax({
                    url: ajax_url,
                    type: 'POST',
                    data: {
                        action: 'filter_posts',
                        category: currentCategory,
                        paged: currentPage, // Send current page to PHP
                    },
                    beforeSend: function() {
                        $postGrid.fadeTo(100, 0.3);
                    },
                    success: function(response) {
                        if (response && response.data && response.data.html) {
                            var $newItems = $(response.data.html);
                            var filteredNewItems = $newItems.filter('.news-item');

                            if (filteredNewItems.length > 0) {
                                $postGrid.isotope('remove', $postGrid.find('.news-item'));

                                $postGrid.append(filteredNewItems).isotope('appended', filteredNewItems);

                                filteredNewItems.imagesLoaded(function () {
                                    $postGrid.isotope('layout');
                                    $postGrid.fadeTo(100, 1);
                                    triggerImageReveal(); // Trigger image reveal after loading
                                });

                                maxPages = response.data.max_num_pages;
                                updateLoadMoreButton();
                            } else {
                                $postGrid.fadeTo(100, 1);
                                $('#load-more').hide();
                            }
                        }
                    },
                    error: function(xhr, status, error) {
                        console.log("AJAX Error: " + error);
                    }
                });

                // Remove `is-checked` class since the filter is removed
                $button.removeClass('is-checked');
            } else {
                // Apply new filter
                activeFilter = filterValue;
                currentCategory = filterValue;
                currentPage = 1;

                $.ajax({
                    url: ajax_url,
                    type: 'POST',
                    data: {
                        action: 'filter_posts',
                        category: currentCategory,
                        paged: currentPage, // Send current page to PHP
                    },
                    beforeSend: function() {
                        $postGrid.fadeTo(700, 0.3);
                    },
                    success: function(response) {
                        if (response && response.data && response.data.html) {
                            var $newItems = $(response.data.html);
                            var filteredNewItems = $newItems.filter('.news-item');

                            if (filteredNewItems.length > 0) {
                                $postGrid.isotope('remove', $postGrid.find('.news-item'));

                                $postGrid.append(filteredNewItems).isotope('appended', filteredNewItems);

                                filteredNewItems.imagesLoaded(function () {
                                    $postGrid.isotope('layout');
                                    $postGrid.fadeTo(100, 1);
                                    triggerImageReveal(); // Trigger image reveal after loading
                                });

                                maxPages = response.data.max_num_pages;
                                updateLoadMoreButton();
                            } else {
                                $postGrid.fadeTo(100, 1);
                                $('#load-more').hide();
                            }
                        }
                    },
                    error: function(xhr, status, error) {
                        console.log("AJAX Error: " + error);
                    }
                });

                // Toggle `is-checked` class on buttons
                $buttonGroup.find('.is-checked').removeClass('is-checked');
                $button.addClass('is-checked');
            }
        });
    });

    // Load more posts on button click
    $('#load-more').on('click', function() {
        if (isLoading) return;
        isLoading = true;
        currentPage++;

        $.ajax({
            url: ajax_url,
            type: 'POST',
            data: {
                action: 'filter_posts',
                category: currentCategory,
                paged: currentPage, // Send the current page number
            },
            beforeSend: function() {
                $('#load-more').text('Loading...');
            },
            success: function(response) {
                if (response && response.data && response.data.html) {
                    var $newItems = $(response.data.html);
                    var filteredNewItems = $newItems.filter('.news-item');

                    if (filteredNewItems.length > 0) {
                        $postGrid.append(filteredNewItems).isotope('appended', filteredNewItems);

                        filteredNewItems.imagesLoaded(function () {
                            $postGrid.isotope('layout');
                            $('#load-more').text('Load More');
                            isLoading = false;
                            triggerImageReveal(); // Trigger image reveal after loading
                        });

                        maxPages = response.data.max_num_pages;
                        updateLoadMoreButton();
                    } else {
                        $('#load-more').hide();
                        isLoading = false;
                    }
                }
            },
            error: function(xhr, status, error) {
                console.log("AJAX Error: " + error);
                $('#load-more').text('Load More');
                isLoading = false;
            }
        });
    });

    // Trigger image reveal animation
    function triggerImageReveal() {
        setTimeout(() => {
            $('.js-image-reveal').each(function () {
                if ($(this).isInViewport()) {
                    $(this).addClass('o-image-reveal');
                }
            });
        }, 500);
    }
};

export { News };
